export default {
  keyState: 'state',
  mustacheTags: ['<%', '%>'],
};
